import { get } from 'lodash'
import { CHECKBOX } from '../constants'

// Use `Map` to dedupe an array while keeping the latest occurrence.
// Not the same as _.uniqueBy from lodash, because the Map will assume that the
// latest occurrence is the most up to date, and will replace the old one while
// keeping the same place in the list.
export function dedupeBy(prop) {
  return arr => {
    const entries = arr.map(val => [get(val, prop), val])
    const map = new Map(entries) // dedupes while keeping original place in list
    return Array.from(map, item => item[1]) // return values only
  }
}

// Dedupes by id prop.
export const dedupeById = dedupeBy('id')

// Helper Function to check if status is already checked
export function isChecked(status) {
  if (!status) {
    return false
  }
  return status === CHECKBOX.CHECKED
}

